import React from "react";
import Section from "./Section";
import { skillGroups } from "../data/profile";

const About = () => (
  <>
    <Section
      id="about"
      title="About"
      subtitle="A quick introduction to who I am and what I do."
    >
      <div className="max-w-prose space-y-4 text-muted">
        <p>
          I came from a pure science background and found my way into code
          during my B.Tech in Computer Science and Business Systems. A
          blockchain workshop in my second year pulled me in, and that
          curiosity became a career. Today I build projects as a software
          engineer in the blockchain space, building secure, reliable systems.
        </p>
        <p>
          I learned with AI, still learn with AI, and now build AI products
          too. I'm excited by the intersection of AI and Web3 and want to keep
          exploring it. I've won international hackathons, built a PvP trading
          game on Base with a team that earned a grant, and I love being part
          of the developer community. I've hosted events and spoken on
          blockchain and zero-knowledge technology, and I'm always happy to
          host or speak again.
        </p>
        <p>
          I'm based in Dubai, pursuing my MSc in Financial Technology, and open
          to new full-stack, AI and Web3 opportunities.
        </p>
      </div>
    </Section>

    <Section
      id="stack"
      title="Stack"
      subtitle="Languages, frameworks, and tools I use to build full-stack Web3 and AI-powered applications."
    >
      <div className="space-y-4">
        {skillGroups.map((group) => (
          <div
            key={group.name}
            className="grid gap-2 rounded-2xl border border-line bg-surface p-5 sm:grid-cols-[10rem_1fr] sm:gap-6 sm:p-6"
          >
            <h3 className="font-semibold sm:pt-1">{group.name}</h3>
            <div className="flex flex-wrap gap-2">
              {group.items.map((skill) => (
                <span
                  key={skill}
                  className="rounded-full border border-line px-3 py-1 text-xs text-muted"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Section>
  </>
);

export default About;
